import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import { merge, $, media, presets } from "glamor";
import theme from "styles/theme";
import { FormatMessage } from "react-globalize";

const NuorderFooter: React.FunctionComponent<{ displayHelpFooter?: boolean }> = ({ displayHelpFooter }) => {
    const styles = merge(
        {
            position: "fixed",
            bottom: "0px",
            left: "0px",
            right: "0px",
            zIndex: 101,
            textAlign: "center",
            padding: "0 0 4px",
            fontSize: "14px",
        },
        $(" .footerTitle", {
            padding: "0 8px 2px",
            color: theme.palette.grey,
            display: "inline-block",
        }),
        $(" .actions", {
            display: "inline-block",
        }),
        $(" .actions > a", {
            color: theme.palette.grey,
            textDecoration: "underline",
            margin: "0 8px",
            display: "inline-block",
            fontSize: "10px",
        }),
        $(" .actions > a.help", {
            display: "none",
        }),
        $(" .helpFooter", {
            paddingBottom: "26px",
        }),
        media(
            presets.phablet,
            merge(
                $(" .actions > a", {
                    fontSize: "14px",
                }),
                $(" .actions > a.help", {
                    display: "inline-block",
                })
            )
        )
    );
    return (
        <div {...styles}>
            {displayHelpFooter && (
                <div className="helpFooter">
                    <FormatMessage
                        path="If you’re still having trouble logging in, [email]contact us[email] for assistance."
                        elements={{
                            email: <a href="mailto:heroes@nuorder.com" />,
                        }}
                    />
                </div>
            )}
            <div className="footerTitle">© Lightspeed NuORDER Inc.</div>
            <div className="actions">
                <a key="privacy" href="https://www.nuorder.com/privacypolicy/" target="_blank">
                    {formatMessage("Privacy")}
                </a>
                <a key="terms" href="https://www.nuorder.com/termsandconditions/" target="_blank">
                    {formatMessage("Terms & Conditions")}
                </a>
                <a className="help" key="help" href="https://helpdesk.nuorder.com/hc/en-us" target="_blank">
                    {formatMessage("Help")}
                </a>
            </div>
        </div>
    );
};

export { NuorderFooter };
export default NuorderFooter;
